import PatientBanner from "./MPatientBanner.vue";
export { type Patient } from "./types";
export default PatientBanner;
